export class WlClick extends CustomEvent<EventInit> {

    static type: string = 'wl-click';

    constructor() {
        super(WlClick.type, {bubbles: true, composed: true});
    }
}